// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMerchandisersListFO_container__oOCbg","emptyList":"UserMerchandisersListFO_emptyList__1dZ_y","addButton":"UserMerchandisersListFO_addButton__HwUh9"};